import { CancelReasonType } from 'domains/models/subscription/cancel_reason/cancel_reason_type';
import { z } from 'zod';

export const CancelReasonTypeEnum = z.nativeEnum(CancelReasonType);
